import Err from '../../models/err';

export default function createLessThanEqualToError(attrName, value) {
  return new Err({
    code: Err.Code.LESS_THAN_OR_EQUAL_TO,
    attr: attrName,
    detail: `Value should be less than or equal to ${value}`,
  });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/factories/error/create_less_than_equal_to_error.js